import axios from 'axios';
import { setupAuthInterceptor } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.configuration_api.account_creation_codes;

const api = setupAuthInterceptor(axios.create({
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/json'
    }
  }));

  export const getAccountCreationCodeByCode = async (invitation_code: string) => {
        return await api.get(`/GetAccountCreationCodeByCode/${invitation_code}`);
      };

  export const setCompanyId = async (invitation_code_id: number, company_id: number) => {
  return await api.post(`/SetCompanyId/${invitation_code_id}`, { company_id });
  };

  export const setLocalId = async (invitation_code_id: number, local_id: number) => {
  return await api.post(`/SetLocalId/${invitation_code_id}`, { local_id });
  };

  export const removeCompanyId = async (invitation_code_id: number) => {
    return await api.delete(`/RemoveCompanyId/${invitation_code_id}`);
  };

  export const removeLocalId = async (invitation_code_id: number) => {
    return await api.delete(`/RemoveLocalId/${invitation_code_id}`);
  };